
import { Component, createRef } from 'react'

import {
  bindTargetMixin,
  SelectInput,
  TextInput,
  RadioGroupInput,
  RxnormAutocompleteInput,
  SaveButton,
  CancelButton
} from '../../../shared/FormBuilder'
import { Paper } from '../../../shared/NarusMaterial'

const CATEGORIES = [
  {
    label: 'Medication',
    code: 'medication'
  },
  {
    label: 'Food',
    code: 'food'
  },
  {
    label: 'Contact',
    code: 'contact'
  },
  {
    label: 'Environment',
    code: 'environment'
  },
  {
    label: 'Other',
    code: 'other'
  }
]

class AllergyForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.allergyName = createRef()
  }

  getValues () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit(this.getValues())
    this.setState({
      isSubmitting: true
    })
  }

  render () {
    const { onCancel } = this.props
    const disableSave =
      (!this.state.value.coding && !this.state.value.freeText) ||
      !this.state.value.reaction
    let agentInput
    if (
      this.state.value &&
      this.state.value.category &&
      this.state.value.category === 'medication'
    ) {
      agentInput = (
        <div>
          <RxnormAutocompleteInput
            ref={this.allergyName}
            name='coding'
            label='Allergy Name'
            required
            tty='IN'
          />
        </div>
      )
    } else {
      agentInput = (
        <div>
          <TextInput
            ref={this.allergyName}
            label='Allergy Name'
            name='freeText'
            required
          />
        </div>
      )
    }

    return (
      <div className='margin-top margin-bottom'>
        <Paper>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className='row'
            onKeyDown={this.props.onKeyDown}
          >
            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                name='category'
                options={CATEGORIES}
                label='Category'
              />
            </div>
            <div className='col-xs-12 col-sm-6'>{agentInput}</div>
          </div>
          <div className='col-xs-offset-1 col-xs-10 margin-top'>
            <RadioGroupInput
              options={[
                {
                  label: 'Low Severity',
                  value: 'low'
                },
                {
                  label: 'High Severity (Anaphylaxis)',
                  value: 'high'
                }
              ]}
              name='severity'
            />
          </div>
          <div className='col-xs-12 col-md-12'>
            <TextInput
              label='Describe Reaction(s)'
              name='reaction'
              required
            />
          </div>
          <div className='row end-xs'>
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }
}

export default AllergyForm
